<template>
  <div class="row mb-5">
    <div class="col-md-12 mb-3">
      <div class="card shadow-sm">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 align-self-center mb-3 mb-md-0">
              <p class="subtitle-1 mb-0">
                If you found this website useful or it’s saved you time, I would be grateful for your support. 😄
              </p>
            </div>
            <div class="col-md-6 text-md-end">
              <!-- BUY ME A COFFEE BADGE -->
              <a href="https://www.buymeacoffee.com/giancarlosgza" target="_blank" rel="noopener">
                <img class="border-radius-0" width="180px" height="54px" alt="Buy me a Coffee - Giancarlos Gza"
                     src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=giancarlosgza&button_colour=3b2eff&font_colour=ffffff&font_family=Poppins&outline_colour=ffffff&coffee_colour=FFDD00"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportMe'
}
</script>